export default __webpack_public_path__ + "static/media/FIRE OR SHOCK DUE TO STATIC ENERGY SIMULATOR.710aed2d.JPG";